import { useRef } from 'react'
import PropTypes from 'prop-types'
import {
  StyledHeaderContainer,
  StyledIcon,
  StyledLogoSlot,
  StyledPanelWrapper,
  StyledSubHeaderContainer,
  StyledTitle,
  StyledTitleContainer,
} from './styled-components'
import iconLogo from './unknown--filled.svg'
import { Panel, StatelessAccordion } from 'baseui/accordion'
import usePanelNew from './usePanelNew'

const RenderLogo = (logo, alt, isPulse) => {
  if (typeof logo === 'string') {
    return <StyledIcon src={logo} alt={alt} $pulse={isPulse} />
  }

  return <StyledLogoSlot $pulse={isPulse}>{logo}</StyledLogoSlot>
}

const PanelNew = props => {
  const panelRef = useRef()
  const { isPulse, expanded, onExpandedChange, isFlashed, panelOverrides } = usePanelNew(props.id)
  const logo = props.logo ?? iconLogo
  const alt = props.alt ?? 'Alternative text...'
  const title = props.title ?? 'Random child'
  const headerContent = props.headerContent ?? null
  const subHeaderContent = props.subHeaderContent ?? null

  if (props.empty === true) {
    return isPulse ? null : <div ref={panelRef} />
  }

  return (
    <>
      <StyledPanelWrapper
        ref={panelRef}
        id={props.id}
        $pulse={isPulse}
        $collapsed={expanded.length === 0}
        $flashed={isFlashed}
      >
        <StatelessAccordion expanded={expanded} onChange={onExpandedChange} accordion={true}>
          <Panel
            key='initial'
            overrides={panelOverrides}
            title={
              <StyledTitleContainer>
                <StyledHeaderContainer>
                  {RenderLogo(logo, alt, isPulse)}
                  <StyledTitle $pulse={isPulse}>{title}</StyledTitle>
                  {headerContent && <StyledTitle $pulse={isPulse}>{headerContent}</StyledTitle>}
                </StyledHeaderContainer>
                <StyledSubHeaderContainer $pulse={isPulse}>{subHeaderContent}</StyledSubHeaderContainer>
              </StyledTitleContainer>
            }
          >
            {props.children}
          </Panel>
        </StatelessAccordion>
      </StyledPanelWrapper>
    </>
  )
}

PanelNew.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.node,
  empty: PropTypes.bool,
  id: PropTypes.string,
  logo: PropTypes.node,
  title: PropTypes.string,
  type: PropTypes.string,
  headerContent: PropTypes.func,
}

export default PanelNew
